import React, { useEffect, useState } from 'react'
import { Button, Input, Form } from 'antd-mobile'
import './Styles/Page01.less'
import { checkPhoneService, pushInfo,pushConfirm } from '../Service/request'
import md5 from 'js-md5';
// import VConsole from 'vconsole';

React.Component.prototype.$md5 = md5;


export default function Name () {
    // new VConsole();

    // let [inNingBo, setInNingBo] = useState(false)//TODO
    let [glbUserId, setGlbUserId] = useState('')
    // let [deviceId, setDeviceId] = useState('')
    // let [glbToken, setGlbToken] = useState('')


    const [form] = Form.useForm()
    useEffect(() => {
        //在这里 需要本地暴露callBack到window 让客户端回调 回调接收的参数为 string的用户信息
        window.callBack = callBack; //暴露方法

        //这个refreshUser方法是 调用了isLogin方法并且isLogin传true 用户登录以后 客户端调用此方法把用户信息返回给你
        window.refreshUser = callBack;//暴露方法
        // window.currentLocation = currentLocation

        const userinfo = getCookie('userinfo')

        if (!userinfo) {
            pushInfo('请在看宁海App中打开！')

            // setDeviceId("6869f98b9b9d7a81")
            // getPhone("1165304925573154053", "80ea7374c068a5c7c441ceea25fab40a")
            return
        }

        const userObject = JSON.parse(userinfo)
        setGlbUserId(userObject.userId)
        console.log("userObject", userObject)
        if(userObject.phone){
            form.setFieldsValue({ tel: userObject.phone })
        }else{
            pushInfo("您的账号还未绑定手机号，请在个人资料中绑定后再来领取！")
            return false;
        }

        // postLocationInfo()
        if (userObject.userId) {
            isLogin('false')
        } else {
            isLogin('true')
        }


    }, [form])

    const callBack = (json) => {
        // let userInfo = JSON.parse(json)
        // setDeviceId(userInfo.deviceId)
        // if (userInfo.userId) {
        //     if (!form.getFieldValue('tel')) {
        //         // getPhone(userInfo.userId, userInfo.token)
        //     }
        // }
    }



    /* const refreshUser = (json) => {
        userInfo = JSON.parse(json)
    } */
    // const getPhone = (userId, token) => {
    //     setGlbUserId(userId)
    //     setGlbToken(token)
    //     getUserInfo({ userId: userId, token: token }, (res) => {
    //         const mobile = res.data
    //         console.log(mobile)
    //         form.setFieldsValue({ tel: mobile })
    //     })
    // }

    const getCookie = (key) => {
        let arr, reg = new RegExp('(^| )' + key + '=([^;]*)(;|$)');
        if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
        else return null;
    }

    const isLogin = (flg) => {
        const u = navigator.userAgent;
        const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
        const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        const navigationMessageIos = {
            method: 'userJson',
            data: { isLogin: flg }, //isLogin传true则跳登录页面，传false则不跳登录页直接获取用户信息
            callBackMethod: 'callBack',
        };
        /* eslint-disable */
        const navigationMessageAndroid = `{"method":"userJson",data:{"isLogin":${flg}},"callBackMethod":"callBack"}`;
        /* eslint-enable */
        if (isIOS) {
            window.webkit.messageHandlers.Native.postMessage(navigationMessageIos);
        }
        if (isAndroid) {
            window.Native.postMessage(navigationMessageAndroid);
        }
    }

    // const postLocationInfo = () => {
    //     //this.$dialog.loading.open('正在定位中,请稍后...');
    //     //this.useClientLocation = 1;
    //     const u = navigator.userAgent;
    //     const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
    //     const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    //     const navigationMessageIos = {
    //         method: "getLocationInfo",
    //         callBackMethod: "currentLocation",
    //     };
    //     /* eslint-disable */
    //     const navigationMessageAndroid =
    //         '{"method":"getLocationInfo","callBackMethod":"currentLocation"}';
    //     /* eslint-enable */
    //     if (isIOS) {
    //         window.webkit.messageHandlers.Native.postMessage(navigationMessageIos);
    //     }
    //     if (isAndroid) {
    //         window.Native.postMessage(navigationMessageAndroid);
    //     }
    //     //that.$dialog.loading.close();
    // }


    // const currentLocation = async (json) => {
    //     let LocationCity = ""

    //     let map = JSON.parse(json);
    //     console.log(map)

    //     localStorage.setItem('lng', JSON.stringify(map.longitude));
    //     localStorage.setItem('lat', JSON.stringify(map.latitude));
    //     if (map.addressInfo) {
    //         if (map.addressInfo.City) {
    //             LocationCity = map.addressInfo.City;
    //         }
    //     }
    //     console.log(LocationCity);

    //     if (LocationCity === "宁波市") {
    //         setInNingBo(true)
    //     } else {
    //         pushInfo("对不起，您不符合本次活动要求！", "抱歉")
    //     }
    // }

    const onFinish = (values) => {

        if (!checkModbile(values.tel)) {
            return
        }

        pushConfirm(`确定领取${values.typ?'3元消费':'10元消费'}红包吗？`,"提示",()=>{
            let string = 'activityId1code2345phone'+values.tel+'wdri5WxvGW/LbS/sxn/OVjcfQQ==';
            let sign = md5(string);
            checkPhoneService({ 
                userId: glbUserId,
                phone: values.tel,
                code:'2345', 
                activityId:1,
                sign,
                // deviceId, 
                // token: glbToken, 
                type: values.typ?values.typ:'1',
            }, (rep) => {
                pushInfo("数币红包发放成功，请您下载数币App开通交行钱包升级到二类钱包后领取", '恭喜您')
            })
        })
        
    }

    const checkModbile = (mobile) => {
        if (!mobile) {
            pushInfo("您的账号还未绑定手机号，请在个人资料中绑定后再来领取！")
            return false;
        }
        //不存在手机号不正确的情况
        // let re = /^1([3,4,5,8,9][0-9]{9}|(7[2-9]{1})[0-9]{8}|(6[0,1,3,4,6,8,9])[0-9]{8})$/;//[0-9]{8}
        // let result = re.test(mobile);
        // if (!result) {
        //     pushInfo("手机号码格式不正确！")
        //     return false;//若手机号码格式不正确则返回false
        // }
        return true;
    }

    const getFive = () => {
        console.log(form.getFieldsValue())
        onFinish({ ...form.getFieldsValue(), typ: "2" })
    }

    return (
        <div className='page01'>
            <Form
                form={form}
                className='form'
                layout='horizontal'
                style={{ '--prefix-width': '4.5rem' }}
                onFinish={onFinish}
                footer={
                    <div>
                        {/* <Button block type='submit' color='primary' >
                            领取10元限定商户消费红包
                        </Button> */}
                        <Button block type='button' color='primary' 
                        // disabled={!inNingBo} 
                        onClick={getFive} className='get5Btn'  >
                            领取3元限定商户消费红包
                        </Button>
                    </div>
                }
            >
                {/* <Form.Header>交行数币拉新活动</Form.Header> */}
                <Form.Item
                    name='tel'
                    label='手机号'
                >
                    <Input readOnly />
                </Form.Item>
            </Form>



        </div>
    )
}

